theme.headerMainMenuModule = (function () {
  function mainMenu() {
    let menuLiSelector = document.querySelectorAll(".header__menu_li");
    menuLiSelector.forEach((item) => {
      if (item.classList.contains("menu__item_has_children")) {
        item.addEventListener("mouseover", (event) => {
          let listDetails = item.querySelector("details");
          listDetails.setAttribute("open", "");
          item.querySelector("summary").setAttribute("aria-expanded", true);
        });
        item.addEventListener("mouseleave", (event) => {
          let listDetails = item.querySelector("details");
          listDetails.removeAttribute("open");
          item.querySelector("summary").setAttribute("aria-expanded", false);
        });
        item.querySelector("summary").addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          let listDetails = item.querySelector("details");
          if (listDetails.hasAttribute("open")) {
            listDetails.removeAttribute("open");
            item.querySelector("summary").setAttribute("aria-expanded", false);
          } else {
            listDetails.setAttribute("open", "");
            item.querySelector("summary").setAttribute("aria-expanded", true);
          }
        });
      }
    });
  }
  return mainMenu;
})();
